import React from "react";
import classes from "./TokenExpire.module.scss";
import SimpleButton from "../../atoms/simple-button/SimpleButton";
import { Navigate, useNavigate } from "react-router-dom";
import teacherImage from "../../static/images/teacher-mail.png";
import headerImage from "../../static/images/typeDiagnosis/DiagnosisQuestionHeader.svg";
import BreadCrumb from "../../molecules/breadcrumb/BreadCrumb";

const TokenExpire = () => {
  const navigate = useNavigate();
  return (
    <div className={classes.container}>
      <div className={classes.body}>
        <div className={classes.teacherImageContainer}>
          <img
            className={classes.teacherImage}
            src={teacherImage}
            alt={teacherImage}
          />
        </div>
        <div className={classes.title}>有効時間が経過しました</div>
        <div className={classes.caption}>
          有効時間を過ぎています。
          お手数おかけいたしますが、以下のボタンからもう一度、
          診断およびメールアドレスの登録をお願いします。
        </div>
        <div className={classes.button}>
          <SimpleButton
            label="ログイン画面へ"
            width="100%"
            color="orange"
            isRadius={true}
            onClick={() => navigate("/login")}
          ></SimpleButton>
        </div>
      </div>
      <BreadCrumb
        data={[
          { displayName: "みらいいコンシェル" },
          { displayName: "有効時間経過" },
        ]}
      />
    </div>
  );
};

export default TokenExpire;
